import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader";
import * as THREE from "three";
import {Color} from "three";

export class loadModel {

    loader;
    dracoLoader;
    mainObject;
    clock;
    bBox;//包围盒
    actions=[];
    autoAnm = true;
    autoAnimation = [];
    time;
    out;
    equipmentMesh = [];
    chairMesh = [];
    colorMesh = [];
    constructor() {
        this.clock = new THREE.Clock();
        this.loader = new GLTFLoader();
        this.dracoLoader = new DRACOLoader();
        this.dracoLoader.setDecoderPath(`${process.env.BASE_URL}tools/`);
        this.loader.setDRACOLoader(this.dracoLoader);
    }

    loadModel(name, hdr, addScene, loaded) {
        //let count = 0;
        let self = this;
        self.bBox = new THREE.Box3();
        self.loader.load(name, object => {
            object.scene.traverse((child) => {
                if(child.isObject3D){
                    if(child.name==="01PJ"
                        ||child.name==="02PJ"
                        ||child.name==="03PJ"
                        ||child.name==="dengzi01"
                        ||child.name==="dengzi02"
                        ||child.name==="dengzi03"){
                        if(child.name==="02PJ")child.visible = false;
                        if(child.name==="03PJ")child.visible = false;
                        if(child.name==="dengzi02")child.visible = false;
                        if(child.name==="dengzi03")child.visible = false;
                        self.pushHideMesh(child);
                    }
                }

                if (child.isMesh) {
                    self.pushHideMesh(child);
                    child.material.envMap = hdr;
                    child.material.envMapIntensity = 1;
                    child.material.side = THREE.DoubleSide;
                    if (child instanceof THREE.Mesh) {
                        if (child.material.map) child.material.map.dispose();
                        child.material.dispose();
                        child.geometry.dispose();
                        child.remove();
                    } else if (child.material) {
                        child.material.dispose();
                        child.remove();
                    }
                }
            });
            self.mainObject = object;
            const bBox = this.bBox.clone().setFromObject(self.mainObject.scene);
            const height = bBox.max.y - bBox.min.y;
            const dist = height / (2 * Math.tan((60 * Math.PI) / 360));
            self.mainObject.scene.scale.set(4 / dist, 4 / dist, 4 / dist);
            addScene(self.mainObject.scene);
            self.animater();
        },xhr=>{
            loaded(Math.floor(xhr.loaded/xhr.total*100));
        });
    }

    actions = [];
    isPaly = false;

    animater() {
        const animations = this.mainObject.animations;
        if (animations && animations.length) {
            this.mixer = new THREE.AnimationMixer(this.mainObject.scene);
            for (let i = 0; i < animations.length; i++) {
                const animation = animations[i];
                //console.log(animation.tracks.splice(1, 1));
                const action = this.mixer.clipAction(animation);
                action.time = 0;
                animation.duration = 2;
                this.autoAnimation.push(animation);
                action.loop = THREE.LoopRepeat;
                action.clampWhenFinished = false;
                this.actions.push(action);
                action && action.play();
            }
        }
    }

    equipment(name){
        for (let i = 0; i < this.equipmentMesh.length; i++) {
            if(name===this.equipmentMesh[i].name){
                this.equipmentMesh[i].visible = true;
            }else {
                this.equipmentMesh[i].visible = false;
            }
        }
    }
    chair(name){
        for (let i = 0; i < this.chairMesh.length; i++) {
            if(name===this.chairMesh[i].name){
                this.chairMesh[i].visible = true;
            }else {
                this.chairMesh[i].visible = false;
            }
        }
    }
    changeColor(color){
        for (let i = 0; i < this.colorMesh.length; i++) {
            this.colorMesh[i].material.color = new Color(color);
        }
    }

    autoDisassemble(index){
        this.mixer.timeScale = 1;
        this.mixer.setTime((1 / 25) * index)
        //this.isPaly = true;
        // for (let i = 0; i < this.actions.length; i++) {
        //     this.actions[i].time = (1 / 25) * index;
        //     console.log(this.actions[i].time);
        // }
    }

    /*
    深拷贝
     */
    deepCopy(obj) {
        var a = JSON.stringify(obj)
        var newobj = JSON.parse(a)
        return newobj
    }
    /*
    添加数组
     */
    pushHideMesh(child) {
        if(child.name==="01PJ"||child.name==="02PJ"||child.name==="03PJ"){
            this.equipmentMesh.push(child);
        }

        if(child.name==="dengzi01"||child.name==="dengzi02"||child.name==="dengzi03"){
            this.chairMesh.push(child);
        }
        if(child.name==="Obj3d66-970258-184-247"
            ||child.name==="Obj3d66-970258-185-682"
            ||child.name==="网格079"
            ||child.name==="网格080"
            ||child.name==="网格078_1"){
            this.colorMesh.push(child);
        }
    }

/*
动画停止
 */
    /*stop() {
        this.isPaly = false;
    }*/
/*
播放动画
 */
   /* play(timeScale) {
        this.mixer.timeScale = timeScale;
        this.isPaly = true;
        /!*for (let i = 0; i < this.actions.length; i++) {
            this.actions[i].clampWhenFinished = true;
        }*!/
    }*/
/*
清除动画
 */
    clearAnimate() {
        this.mixer.time = 0;
        for (let i = 0; i < this.actions.length; i++) {
            this.actions[i] && this.actions[i].reset();
        }
    }

    update() {
        let delta = this.clock.getDelta();
        if (this.mixer && this.isPaly) {
            this.mixer.update(delta);
        }
    }

    //清除缓存
    clearCache(scene) {
        if (!scene) return;
        this.dispose(scene, scene);
    }

    //清除模型
    dispose(parent, child) {
        if (child.children.length) {
            let arr = child.children.filter(x => x);
            arr.forEach(a => {
                this.dispose(child, a)
            })
        }

        if (child instanceof THREE.Mesh) {
            if (child.material.map) child.material.map.dispose();
            child.material.dispose();
            child.geometry.dispose();
            child.remove();
            parent.remove(child);
        } else if (child.material) {
            child.material.dispose();
            child.remove();
            parent.remove(child);
        } else if (child instanceof THREE.Group) {
            child.remove();
            parent.remove(child);
        } else if (child.type === "Object3D") {
            child.remove();
            parent.remove(child);
        }
    }

}
